import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface RegularDeploymentItem {
  windows_download_url: string // Windows安装包
  pin_code: string // pin码
  team_name: string
  win_server_download_url: string
  windows_server2003_download_url: string
  windows_xp_download_url: string
  macos_arm64_download_url: string
  macos_amd64_download_url: string
  macos_systems: object
  linux_download_map: Record<string, unknown>,
  systems: string[],
  deploy_share_token: string
}

export interface DeploymentVersionsReq {
  /** 分组id */
  group_id?: number
  /** 是否拼接分组id */
  with_group?: boolean
}

@Injectable()
export class ClientAliveService {
  constructor (private http: Http) {

  }

  fetchDeploymentVersions (data: DeploymentVersionsReq = {}) {
    return this.http.post<RegularDeploymentItem>('/team/deploy_conf/get', data)
  }
}
